import { render, staticRenderFns } from "./SelectGroupMemberModal.vue?vue&type=template&id=5a706563&scoped=true&"
import script from "./SelectGroupMemberModal.vue?vue&type=script&lang=js&"
export * from "./SelectGroupMemberModal.vue?vue&type=script&lang=js&"
import style0 from "./SelectGroupMemberModal.vue?vue&type=style&index=0&id=5a706563&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a706563",
  null
  
)

export default component.exports